import { render, staticRenderFns } from "./TrainerStatistics.vue?vue&type=template&id=779db0e5&scoped=true"
import script from "./TrainerStatistics.vue?vue&type=script&lang=js"
export * from "./TrainerStatistics.vue?vue&type=script&lang=js"
import style0 from "./TrainerStatistics.vue?vue&type=style&index=0&id=779db0e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779db0e5",
  null
  
)

export default component.exports